import CustomHttpService from './custom-http.service';
import EncodeDecodeType from '../actiontype/encode-decode-type';
import Config from '../config/config';
import UtilService from './util.service';
import { UserAction } from '../constants/user-action.constant';

export default class DndRegistrationService {
    static filterCategories(item) {
        if (item['fieldCategory'] === 'Category') {
            return true;
        }
        return false;
    }

    // //Fetch DND Registration Preference
    // static fetchDndPreferences(msisdn) {
    //     let url = UtilService.getFullUrl([Config.baseUrls.HELPSUPPORT.HELPSUPPORT_CONTEXT_URI, "dndV2/fetch-preferences?msisdn=" + msisdn]);
    //     return CustomHttpService.get(url, {}, EncodeDecodeType.HELPSUPPORT);
    // }

    //Fetch DND Registration Preference
    static fetchDndPreferences(msisdn) {
        let url = UtilService.getFullUrl([Config.baseUrls.HELPSUPPORT.NEW_DIGITAL_PROFILE_CONTEXT_URI, "preferences?msisdn=" + msisdn]);
        return CustomHttpService.get(url, {}, EncodeDecodeType.HELPSUPPORT, 0, false);
    }

    //Fetch DND Mapping 
    static fetchDndMapping() {
        const url = UtilService.getFullUrl([Config.baseUrls.HELPSUPPORT.NEW_DIGITAL_PROFILE_CONTEXT_URI, "mapping"]);
        return CustomHttpService.get(url, {}, EncodeDecodeType.HELPSUPPORT, 0, false);
    }

    //Call DND Mapping and DND Registration Preference in parallel
    static fetchDndMappingAndPreferences(msisdn) {
        let urls = [this.fetchDndPreferences(msisdn), this.fetchDndMapping()];;
        return CustomHttpService.getAll(urls);
    }

    //dnd preferences submission
    static dndRegistrationSubmit(data) {
        let url = Config.baseUrls.HELPSUPPORT.NEW_DIGITAL_PROFILE_CONTEXT_URI + "preferences";
        return CustomHttpService.post(url, JSON.stringify(data), {headers: {"Content-Type": "application/json"}}, EncodeDecodeType.HELPSUPPORT, 0, null, false);
    }

    //Map DND Preferences with DND Mapping file
    static createRegistrationPreferenceList(dndMappingList, dndPreferences, preference) {
        let selectedPreferences = {};
        dndMappingList.forEach(element => {
            const fieldCode = element['fieldCode'];
            const displayName = element['displayName'];
            element['selected'] = false;
            selectedPreferences[displayName] = selectedPreferences[displayName] ? selectedPreferences[displayName] : {};
            selectedPreferences[displayName]['fieldCode'] = element['fieldCode'];
            selectedPreferences[displayName]['dltCode'] = element['dltCode'];
            selectedPreferences[displayName]['fieldCategory'] = element['fieldCategory'];
            selectedPreferences[displayName]['priority'] = element['priority'];
            selectedPreferences[displayName]['isChecked'] = false;
            dndPreferences && dndPreferences[fieldCode] && Array.isArray(dndPreferences[fieldCode]) &&  dndPreferences[fieldCode].forEach(preferenceCode => {
                if (element['dltCode'] === preferenceCode) {
                    element['selected'] = true;
                    selectedPreferences[displayName]['isChecked'] = true;
                }
                if (preference === UserAction.MOBILE_REGISTRATION && element['fieldCode'] === 'time') {
                    dndPreferences['defaulttime'].forEach(defTimeCode => {
                        if (element['dltCode'] === defTimeCode) {
                            selectedPreferences[displayName]['defaultTime'] = true;
                        }
                    })
                }
            });
        });
        return selectedPreferences;
    }

    //Auto-select the preferences on basis of BLOCK ALL, BLOCK PROMO or ALL TIME/DAY/MODE 
    static getAutoSelectedRegistrationPreferencesList(preferencesList, source) {
        let autoSelectedPreferencesList = {};
        for (const key of Object.keys(preferencesList)) {
            // Source = true states Manual selection from DND Registration page
            if (source) {
                if (preferencesList[key]['dltCode'] === source['dltCode']) {
                    if (preferencesList[key] && parseInt(preferencesList[key]['priority']) > 1) {
                        if (preferencesList[key]['isChecked']) {
                            autoSelectedPreferencesList = this.autoSelectAllBands(preferencesList, preferencesList[key]);
                            break;
                        }
                        else if (!preferencesList[key]['isChecked']) {
                            autoSelectedPreferencesList = this.deSelectAllBands(preferencesList, preferencesList[key]);
                            break;
                        }
                    }
                    else if (preferencesList[key] && parseInt(preferencesList[key]['priority']) === 1) {
                        autoSelectedPreferencesList = this.checkForCategorySelection(preferencesList, preferencesList[key]);
                        break;
                    }
                }
            }
            // Source = false states list rendering for first time and making automatic selection(s) if select all is true 
            else {
                if (preferencesList[key] && parseInt(preferencesList[key]['priority']) > 1) {
                    if (preferencesList[key]['isChecked']) {
                        autoSelectedPreferencesList = this.autoSelectAllBands(preferencesList, preferencesList[key]);
                    }
                }
                else {
                    // No change in Preference list state
                }
            }
        }
        return autoSelectedPreferencesList;
    }
    //If select all is true for any category, then select corresponding options
    static autoSelectAllBands(preferencesList, selectedKey) {
        const category = selectedKey['fieldCategory'];
        const priority = selectedKey['priority'];
        for (const key of Object.keys(preferencesList)) {
            if (preferencesList[key]['fieldCategory'] === category) {
                //Block all and block promo can't be selected together
                if (category === 'Category') {
                    if (priority === "2" && preferencesList[key]['priority'] === "3") {
                        preferencesList[key]['isChecked'] = false;
                    }
                    else if (priority === "3" && preferencesList[key]['priority'] === "2") {
                        preferencesList[key]['isChecked'] = false;
                    }
                    else {
                        preferencesList[key]['isChecked'] = true;
                    }
                }
                else {
                    preferencesList[key]['isChecked'] = true;
                }
            }
        }
        if (category === 'Category') {
            if (parseInt(priority) > 1) {
                preferencesList = this.deSelectAllBandsExceptCategory(preferencesList);
            }
        }
        return preferencesList;
    }
    //If select all is false for any category, then de-select corresponding options
    static deSelectAllBands(preferencesList, selectedKey) {
        const category = selectedKey['fieldCategory'];
        for (const key of Object.keys(preferencesList)) {
            if (preferencesList[key]['fieldCategory'] === category) {
                preferencesList[key]['isChecked'] = false;
            }
        }
        return preferencesList;
    }
    //If Bock All or Block Promo is selected then deselect AllModes/ AllDays/ AllDates
    static deSelectAllBandsExceptCategory(preferencesList) {
        for (const key of Object.keys(preferencesList)) {
            if (preferencesList[key]['fieldCategory'] !== 'Category') {
                preferencesList[key]['isChecked'] = false;
            }
        }
        return preferencesList;
    }
    //Check if all options for any category is true
    static checkForCategorySelection(preferencesList, selectedKey) {
        const category = selectedKey['fieldCategory'];
        let selectedPreferencesList;
        let allChecked = true;
        for (const key of Object.keys(preferencesList)) {
            if (preferencesList[key]['fieldCategory'] === category) {
                if (preferencesList[key] && parseInt(preferencesList[key]['priority']) === 1) {
                    if (!preferencesList[key]['isChecked']) {
                        allChecked = false;
                        break;
                    }
                }
            }
        }
        selectedPreferencesList = this.selectCategoryBand(preferencesList, selectedKey, allChecked);
        return selectedPreferencesList;
    }
    //Select/ de-select 'select all' option for any category
    static selectCategoryBand(preferencesList, selectedKey, allChecked) {
        const category = selectedKey['fieldCategory'];
        if (category === 'Category') {
            if (allChecked) {
                preferencesList = this.deSelectAllBandsExceptCategory(preferencesList);
            }
        }
        for (const key of Object.keys(preferencesList)) {
            if (preferencesList[key] && parseInt(preferencesList[key]['priority']) > 1) {
                if (preferencesList[key]['fieldCategory'] === category) {
                    if (category === 'Category') {
                        if (preferencesList[key]['priority'] === "3") {
                            preferencesList[key]['isChecked'] = allChecked;
                        }
                        else {
                            preferencesList[key]['isChecked'] = false;
                        }
                    }
                    else {
                        preferencesList[key]['isChecked'] = allChecked;
                    }
                }
            }
            else {

            }
        }
        return preferencesList;
    }

    //Create request for preference registration
    static createRegistrationRequest(selectedPreferenceList) {
        let registrationReqObj = {};
        for (let name in selectedPreferenceList) {
            if (selectedPreferenceList.hasOwnProperty(name) && selectedPreferenceList[name]['isChecked']) {
                const fieldCode = selectedPreferenceList[name]['fieldCode'];
                registrationReqObj[fieldCode] = registrationReqObj[fieldCode] ? registrationReqObj[fieldCode] : [];
                registrationReqObj[fieldCode].push(selectedPreferenceList[name]['dltCode']);
            }
        }
        return registrationReqObj;
    }

    //Filtering dnd mapping response based on field category as Complaint flow needs to display only categories.
    static fetchDndCategoryMapping(data) {
        // Default category option for complaint page
        const selectCategory = [{
            displayName: "Select Category",
            dltCode: "",
            fieldCategory: "Category",
            fieldCode: "ctgr",
            fieldType: "",
            priority: "1"
        }];
        let dndCategoryMapping = data;
        //Filter category list from DND Mapping list
        dndCategoryMapping = dndCategoryMapping.filter(item => item['fieldCategory'] === 'Category');
        const finalDndCategoryMapping = [...selectCategory, ...dndCategoryMapping];
        return finalDndCategoryMapping;
    }

    //get request number
    static getRequestNumber(dndRegistrationResponse) {
        let reqNo = '';
        if (dndRegistrationResponse && dndRegistrationResponse['payload']) {
            const payload = dndRegistrationResponse['payload'];
            reqNo = payload[0] && payload[0]['reqno'] ? payload[0]['reqno'] : '';
        }
        return reqNo;
    }

    //check whether BLOCK ALL/ BLOCK PROMO is selected and enable/ disable More Preferences accordingly
    static enableMorePreferences(preferencesList) {
        for (const key of Object.keys(preferencesList)) {
            if (preferencesList[key]['fieldCategory'] === 'Category') {
                if (parseInt(preferencesList[key]['priority']) > 1 && preferencesList[key]['isChecked']) {
                    return false;
                }
            }
        }
        return true;
    }

    //Create category wise selected preferences for summary section
    static getCategorywiseSelectedPreferenceList(preferencesList) {
        let categorywiseSelectedPreferenceList = {};
        let allCategorySelectionMap = {}
        for (let key of Object.keys(preferencesList)) {
            if (preferencesList[key]['isChecked']) {
                const fieldCategory = preferencesList[key]['fieldCategory'];
                const fieldCode = preferencesList[key]['fieldCode'];
                //Initialize allCategorySelectionMap: true for each fieldcategory if all fields are selected
                if (!allCategorySelectionMap[fieldCategory]) {
                    allCategorySelectionMap[fieldCategory] = false;
                }
                // mark true for fieldcategory if all fields are selected
                if (parseInt(preferencesList[key]['priority']) > 1) {
                    allCategorySelectionMap[fieldCategory] = true;
                }

                const selectedPreference = key;
                if (!categorywiseSelectedPreferenceList[fieldCategory] || (allCategorySelectionMap[fieldCategory] && parseInt(preferencesList[key]['priority']) > 1)) {
                    categorywiseSelectedPreferenceList[fieldCategory] = [];
                    if (fieldCategory === "Category") {
                        categorywiseSelectedPreferenceList["defaultTime"] = [];
                    }
                }
                // default time addition 
                if (fieldCode === "time" && preferencesList[key]["defaultTime"]) {
                    if (!categorywiseSelectedPreferenceList["defaultTime"]) {
                        categorywiseSelectedPreferenceList["defaultTime"] = [];
                    }
                    categorywiseSelectedPreferenceList["defaultTime"].push(selectedPreference);
                }
                if ((allCategorySelectionMap[fieldCategory] && parseInt(preferencesList[key]['priority']) > 1) ||
                    (!allCategorySelectionMap[fieldCategory] && parseInt(preferencesList[key]['priority']) === 1)
                ) {
                    if (!preferencesList[key]["defaultTime"]) {
                        categorywiseSelectedPreferenceList[fieldCategory].push(selectedPreference);
                    }
                }

            }
        }
        return categorywiseSelectedPreferenceList;
    }

}